import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(auth)/register/page.jsx")